import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_NEXT_NUMBERING_OF_SECRETARY } from "../Schema/Secretarait";

export const useGetNextNumberingOfSecretary = ({
  candidateType,
  partyId,
  setFieldValue,
  dialogTitle,
}) => {
  const { refetch } = useQuery(GET_NEXT_NUMBERING_OF_SECRETARY, {
    variables: {
      partyId: partyId || "",
      candidateType: candidateType || "",
    },
    onCompleted: ({ getNextNumberingOfSecretary }) => {
      if (dialogTitle === "Create")
        setFieldValue("numbering", getNextNumberingOfSecretary);
    },
  });
  useEffect(() => {
    refetch();
  }, [partyId, candidateType]);

  return { refetch };
};
